import { Grid } from "@material-ui/core";
import {
  Dispatch,
  FunctionComponent,
  SetStateAction,
  useContext,
  useEffect,
} from "react";
import { None, Option, Some } from "space-monad";
import styled from "styled-components";
import { useAppLoader } from "../../../../../components/loader/app-loader-hook";
import { StepperContext } from "../../../../../components/stepper/context";
import { Code } from "../../../../../components/typography";
import { useBrowserWallet } from "../../../../../store/wallets/crypto";
import { device } from "../../../../../styles/media";
import { formatEther } from "../../../../../utils/utils";
import { StakeContext } from "../../context";
import { StyledDivider, useAcceptedStakingTerms } from "../common";

interface IConfirmProps {
  stake: boolean;
  setError: Dispatch<SetStateAction<Option<Error>>>;
}

const Amount = styled.h3`
  font-size: 1.4em;
  font-weight: 700;
  text-align: center;

  @media ${device.tablet} {
    margin-top: 2em;
  }
`;

const WrapperConfirm = styled.form`
  padding: 0 2em;
  max-width: 100%;

  @media ${device.tablet} {
    width: 32em;
    height: 32em;
  }
`;

const Confirm: FunctionComponent<IConfirmProps> = ({ stake, setError }) => {
  const { accounts } = useBrowserWallet();
  const { claimRewards, currentContract, stakingContractId } = useContext(
    StakeContext
  );
  const { setValidation, setIsNextEnabled } = useContext(StepperContext);
  const { component, termsAccepted } = useAcceptedStakingTerms();

  const loader = useAppLoader();

  useEffect(() => {
    setIsNextEnabled(termsAccepted);
    return () => setIsNextEnabled(true);
  }, [termsAccepted]);

  useEffect(() => {
    setError(None);
    setValidation(() => () =>
      loader(
        claimRewards(stake).catch((e: Error) => {
          setError(Some(e));
          return Promise.resolve();
        })
      )
    );
    return () => setValidation(() => () => Promise.resolve());
  }, [setValidation]);

  return (
    <WrapperConfirm>
      {Option.all([accounts, stakingContractId]).fold(
        () => null,
        ([accs, add]) => (
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <p>Your wallet:</p>
              <Code>{accs.coinbase}</Code>
            </Grid>
            <Grid item xs={12}>
              <p>Destination contract:</p>
              <Code>{add}</Code>
            </Grid>
          </Grid>
        )
      )}
      <StyledDivider />
      {currentContract
        .map((x) => x.walletInfo)
        .fold(
          () => null,
          ({ rewards }) => (
            <Amount>
              $SKRT {formatEther(stake ? rewards.full : rewards.effective)}
            </Amount>
          )
        )}
      <StyledDivider />
      {component}
    </WrapperConfirm>
  );
};

export default Confirm;
